<template>
  <div class="p-16 bg-surface-tertiary">
    <div class="flex flex-col">
      <p
        v-if="
          cardData?.variant?.Prices?.Price?.RegularPrice !==
          cardData?.variant?.Prices?.Price?.Price
        "
        class="strike-through w-fit heading-xxs text-text-on-highlight"
      >
        {{ cardData?.variant?.Prices?.Price?.RegularPrice }}
      </p>
      <p class="heading-xs text-text-on-highlight">
        {{ cardData?.variant?.Prices?.Price?.Price }} kr
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  cardData?: ProductCard;
}

defineProps<Props>();
</script>

<style scoped lang="scss">
.strike-through {
  &:before {
    background: linear-gradient(
      to left top,
      transparent 45.5%,
      var(--text-on-highlight) 47.5%,
      var(--text-on-highlight) 52.5%,
      transparent 54.5%
    ) !important;
  }
}
</style>
